export default {
  authUser: state => state.authUser,
  authUserData: state => state.authUserData,
  authUserUid: (state, getters) => getters['authUser']?.uid || undefined
}
